import React, { useState } from 'react'
import {Star, Quote, Send} from 'lucide-react'

const reviews = [
  {
    name: "Franck Duarte",
    vehicle: "BMW Série 3",
    date: "Janvier 2025",
    rating: 5,
    comment: "Achat d'un serie 3 il y a 3 semaines auprès de Cyril. Livraison dans les temps, préparation aux petits oignons. La voiture a été lavée comme neuve ! Je recommande !",
    location: "Aix-en-Provence"
  },
  {
    name: "Fatima Diallo",
    vehicle: "Peugeot 3008 GT",
    date: "Décembre 2024",
    rating: 4,
    comment: "Bonne experience . La livraison de mon 3008 a pris quelques jours de plus que prevu mais le vehicule était impeccable. L'équipe a été transparente sur les delais, 4 étoiles  pour le leger retard",
    location: "Rueil-Malmaison"
  },
  {
    name: "Julien Martin",
    vehicle: "Mercedes Classe A",
    date: "Novembre 2024",
    rating: 5,
    comment: "Excellent accompagnement lors de l'achat de ma Mercedes. L'équipe a pris le temps de m'expliquer toute les options et le processus. Livraison rapide et vehicule conforme à mes attentes. Un grand merci!",
    location: "Aix Les Bains"
  },
  {
    name: "Marie Lefebvre",
    vehicle: "Volkswagen Tiguan",
    date: "Octobre 2024",
    rating: 3,
    comment: "Plutot satisfaite de mon achat. Le prix etait compétitif mais la livraison à un quelque peu tardé. , Je recommande malgrès tout Auto star et merci à Erwan qui a su me rassurer et répondre a mes appels durant l'attente de ma voiture.",
    location: "Vitrolles"
  },
  {
    name: "Rachid Amrani",
    vehicle: "Renault Mégane E-Tech",
    date: "Septembre 2024",
    rating: 5,
    comment: "J'ai passé commande le 22 septembre une mégane électrique pour ma fille. L'equipe d'AUTO STAR est très competente. Mon véhicule a été livré dans les temps et en parfait etat. Très bonne expérience",
    location: "Sète"
  },
  {
    name: "Lucas Bernard",
    vehicle: "Audi A4 Avant",
    date: "Août 2024",
    rating: 5,
    comment: "Un service remarquable! Erwan m'a trouvé un très beau Audi A4 en Allemagne à un bon tarif . Le suivi etait excellent. Je recommande sans hesité !",
    location: "Grasse"
  }
]

export default function Reviews() {
  return (
    <section id="avis" className="relative py-16 sm:py-20 md:py-24 bg-gradient-to-b from-black via-gray-900 to-black overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-red-500 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 md:mb-20 animate-in fade-in slide-in-from-bottom duration-700">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4 sm:mb-6 leading-tight" style={{ fontFamily: 'Syne, sans-serif' }}>
            Ils nous font
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-white to-red-500">confiance</span>
          </h2>
          <p className="text-white/70 text-base sm:text-lg md:text-xl max-w-3xl mx-auto" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Découvrez les retours d'expérience de nos clients satisfaits
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-white/5 to-white/[0.02] backdrop-blur-sm border border-white/10 rounded-2xl p-6 sm:p-8 hover:scale-105 hover:border-blue-400/40 transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/20 animate-in fade-in slide-in-from-bottom"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Quote Icon */}
              <Quote className="text-blue-400/30 mb-4" size={32} />

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={i} className="text-yellow-400 fill-yellow-400" size={18} />
                ))}
              </div>

              {/* Comment */}
              <p className="text-white/80 text-sm sm:text-base leading-relaxed mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
                "{review.comment}"
              </p>

              {/* Author Info */}
              <div className="border-t border-white/10 pt-4">
                <div className="flex items-start justify-between">
                  <div>
                    <p className="text-white font-bold text-base sm:text-lg mb-1">{review.name}</p>
                    <p className="text-blue-400 text-xs sm:text-sm font-semibold mb-1">{review.vehicle}</p>
                    <p className="text-white/50 text-xs">{review.location} • {review.date}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Review Form */}
        <div id="formulaire-avis" className="mt-16 sm:mt-20 max-w-3xl mx-auto">
          <div className="bg-gradient-to-br from-white/10 to-white/[0.02] backdrop-blur-sm border border-white/20 rounded-2xl p-6 sm:p-10">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3" style={{ fontFamily: 'Syne, sans-serif' }}>
                Laisser votre avis
              </h3>
              <p className="text-white/70 text-sm sm:text-base" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Partagez votre expérience avec AUTO STAR
              </p>
            </div>

            <form className="space-y-6" onSubmit={(e) => {
              e.preventDefault()
              alert('Merci pour votre avis! Il sera publié après validation par notre équipe.')
              e.currentTarget.reset()
            }}>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-white/80 text-sm font-semibold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    Votre nom *
                  </label>
                  <input 
                    type="text" 
                    required
                    className="w-full bg-white/5 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-blue-400 transition-colors"
                    placeholder="Jean Dupont"
                  />
                </div>
                <div>
                  <label className="block text-white/80 text-sm font-semibold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    Véhicule acheté *
                  </label>
                  <input 
                    type="text" 
                    required
                    className="w-full bg-white/5 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-blue-400 transition-colors"
                    placeholder="Audi A3"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-white/80 text-sm font-semibold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    Votre ville *
                  </label>
                  <input 
                    type="text" 
                    required
                    className="w-full bg-white/5 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-blue-400 transition-colors"
                    placeholder="Marseille"
                  />
                </div>
                <div>
                  <label className="block text-white/80 text-sm font-semibold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    Note *
                  </label>
                  <select 
                    required
                    className="w-full bg-white/5 border border-white/20 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-blue-400 transition-colors"
                  >
                    <option value="" className="bg-gray-900">Sélectionnez</option>
                    <option value="5" className="bg-gray-900">⭐⭐⭐⭐⭐ Excellent</option>
                    <option value="4" className="bg-gray-900">⭐⭐⭐⭐ Très bien</option>
                    <option value="3" className="bg-gray-900">⭐⭐⭐ Bien</option>
                    <option value="2" className="bg-gray-900">⭐⭐ Moyen</option>
                    <option value="1" className="bg-gray-900">⭐ Insuffisant</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-white/80 text-sm font-semibold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  Votre avis *
                </label>
                <textarea 
                  required
                  rows={6}
                  className="w-full bg-white/5 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-blue-400 transition-colors resize-none"
                  placeholder="Partagez votre expérience avec AUTO STAR..."
                />
              </div>

              <div className="text-center">
                <button 
                  type="submit"
                  className="inline-flex items-center gap-3 bg-gradient-to-r from-blue-600 to-blue-500 text-white px-10 py-4 rounded-full font-bold text-base sm:text-lg hover:from-blue-500 hover:to-blue-400 transition-all shadow-lg hover:shadow-blue-500/50 hover:scale-105"
                >
                  <Send size={20} />
                  Publier mon avis
                </button>
                <p className="text-white/50 text-xs sm:text-sm mt-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  Votre avis sera publié après validation par notre équipe
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}
